/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SuggestProductNameQueryVariables = Exact<{
  name: string;
  subFamily: string;
  brand?: string | null | undefined;
  description?: string | null | undefined;
}>;


export type SuggestProductNameQuery = { suggestProductName: Array<{ slot: string, suggestions: Array<string> }> };


export const SuggestProductNameDocument = /*#__PURE__*/ gql`
    query SuggestProductName($name: String!, $subFamily: String!, $brand: String, $description: String) {
  suggestProductName(
    name: $name
    subFamily: $subFamily
    brand: $brand
    description: $description
  ) {
    slot
    suggestions
  }
}
    `;

/**
 * __useSuggestProductNameQuery__
 *
 * To run a query within a React component, call `useSuggestProductNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestProductNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestProductNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      subFamily: // value for 'subFamily'
 *      brand: // value for 'brand'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSuggestProductNameQuery(baseOptions: Apollo.QueryHookOptions<SuggestProductNameQuery, SuggestProductNameQueryVariables> & ({ variables: SuggestProductNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestProductNameQuery, SuggestProductNameQueryVariables>(SuggestProductNameDocument, options);
      }
export function useSuggestProductNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestProductNameQuery, SuggestProductNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestProductNameQuery, SuggestProductNameQueryVariables>(SuggestProductNameDocument, options);
        }
// @ts-ignore
export function useSuggestProductNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestProductNameQuery, SuggestProductNameQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestProductNameQuery, SuggestProductNameQueryVariables>;
export function useSuggestProductNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestProductNameQuery, SuggestProductNameQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestProductNameQuery | undefined, SuggestProductNameQueryVariables>;
export function useSuggestProductNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestProductNameQuery, SuggestProductNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestProductNameQuery, SuggestProductNameQueryVariables>(SuggestProductNameDocument, options);
        }
export type SuggestProductNameQueryHookResult = ReturnType<typeof useSuggestProductNameQuery>;
export type SuggestProductNameLazyQueryHookResult = ReturnType<typeof useSuggestProductNameLazyQuery>;
export type SuggestProductNameSuspenseQueryHookResult = ReturnType<typeof useSuggestProductNameSuspenseQuery>;
export type SuggestProductNameQueryResult = Apollo.QueryResult<SuggestProductNameQuery, SuggestProductNameQueryVariables>;